import { render, staticRenderFns } from "./regis.vue?vue&type=template&id=621a835b&scoped=true&"
import script from "./regis.vue?vue&type=script&lang=js&"
export * from "./regis.vue?vue&type=script&lang=js&"
import style0 from "./regis.vue?vue&type=style&index=0&id=621a835b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a835b",
  null
  
)

export default component.exports